(function (window) {
  /**
   * Given a marker it checks if there is an address associated with it. If
   * not it will try to create an address from it's lat/lon. When it's done it
   * will fire a success callback with the address.
   *
   * @param {object} marker A marker object. Expects there to be an `addr`
   * property on the object
   *
   * @param {function} successCallback Function to call when geocoding is
   * complete and it was successful. Will pass the address as the first param
   *
   * @return {undefined} Returns nothing but will lazily inject the address if
   * an address is retrieved
   */
  window.BatchGeoInfoWindowCreateAddress = function (marker, successCallback) {
    var row =
      window.batchGeoGoogleMapsManager.settings.markersData.mapRS[marker.r];
    if (
      (marker.addr.trim().length === 0 ||
        marker.addr == row.lt + ", " + row.ln) &&
      row.lt
    ) {
      var geocoder = new google.maps.Geocoder();
      geocoder.geocode(
        {
          location: new google.maps.LatLng(row.lt, row.ln),
        },
        function (results, status) {
          if (
            status == google.maps.GeocoderStatus.OK &&
            results[0] &&
            results[0].formatted_address
          ) {
            successCallback(results[0].formatted_address);
          }
        },
      );
    }
  };
})(window);
